export default "__VITE_ASSET__FtiY5nf1__"